import type { CentreData } from './types';

export const clydeData: CentreData = {
  slug: 'clyde',
  name: 'Schoolola Clyde',
  suburb: 'Clyde',
  state: 'VIC',
  stateName: 'Victoria',
  region: 'South East Melbourne',
  status: 'comingSoon',
  yearLevels: 'Prep - Year 8',
  canonicalPath: '/centres/clyde/',
  heroImage: 'https://schoolola.com.au/centres/clyde-og.jpg',
  address: {
    city: 'Clyde',
  },
  contact: {
    email: 'clyde.vic@schoololatutoring.com.au',
  },
  heroSubtitle:
    'A new Schoolola centre is opening in Clyde. NAPLAN, selective entry and scholarship preparation by qualified Victorian Curriculum teachers.',
  breadcrumb: { stateHref: '/states/victoria', regionLabel: 'South East Melbourne' },
  programs: [
    {
      id: 'foundations',
      title: 'Foundations Course',
      yearPill: { label: 'Prep - Year 8', tone: 'success' },
      tagline: 'Core English and maths · all year levels',
      bullets: ['Phonics, fluency, comprehension', 'Number sense to algebra readiness', 'Writing structure across genres'],
      educationalLevel: 'Prep to Year 8',
      description: 'Core English and mathematics tutoring for Prep through Year 8 students at Schoolola Clyde, aligned to the Victorian Curriculum.',
    },
    {
      id: 'naplan',
      title: 'NAPLAN Preparation',
      yearPill: { label: 'Yr 3, 5', tone: 'info' },
      tagline: '10-week term aligned to ACARA',
      bullets: ['Reading and writing', 'Numeracy strategies', 'Language conventions'],
      educationalLevel: 'Year 3 and Year 5',
      description: '10-week term NAPLAN preparation course covering reading, writing, language conventions and numeracy, aligned to ACARA test specifications.',
    },
    {
      id: 'selective',
      title: 'Selective Entry High School Preparation',
      yearPill: { label: 'Most popular', tone: 'info' },
      tagline: 'Year 5-8 · Selective entry track',
      bullets: ['Verbal and quantitative reasoning', 'Reading comprehension', 'Mathematical reasoning'],
      featured: 'popular',
      educationalLevel: 'Year 4 to Year 6',
      description: 'Selective entry high school preparation covering verbal reasoning, quantitative reasoning, reading comprehension and mathematical reasoning for the Victorian SEAL test pathway.',
    },
    {
      id: 'sec',
      title: 'SEC Scholarship Exam Course',
      yearPill: { label: 'Yr 4-6', tone: 'info' },
      tagline: 'ACER and Edutest scholarship preparation',
      bullets: ['SEAL/SEALP training', 'Strategic exam techniques', 'Practice test cycles'],
      educationalLevel: 'Year 4 to Year 6',
      description: 'Schoolola SEC programmes - SEC TMRW (booklet-based) and the SEC Scholarship Exam Course - preparing students primarily for ACER and Edutest scholarship exams, with SEAL/SEALP training and structured practice test cycles.',
      prerequisites: 'Basic literacy and numeracy at year-level expectations.',
    },
  ],
  differentiators: [
    {
      title: 'Victorian Curriculum specialists',
      body: "Our team has analysed the curriculum in depth. Lessons map to what your child's school actually teaches, not generic worksheets.",
      icon: 'BookOpen',
    },
    {
      title: 'Measurable progress reports',
      body: 'Quarterly assessments tracked against ACARA bands. Parents see exactly where their child sits.',
      icon: 'LineChart',
    },
    {
      title: 'Small group ratios',
      body: 'Maximum 6 students per tutor. Enough peer dynamics, enough individual attention.',
      icon: 'Users',
    },
    {
      title: 'Selective and scholarship track record',
      body: 'Network students placed at Suzanne Cory, Mac.Robertson Girls, Melbourne High and Nossal High.',
      icon: 'Trophy',
    },
  ],
  faqs: [
    {
      question: 'What year levels will Schoolola Clyde tutor?',
      answer: 'Prep through Year 8. Foundations covers all year levels in English and maths; NAPLAN, selective entry and scholarship programs target specific testing years.',
    },
    {
      question: 'Which programs will be offered?',
      answer: 'Foundations, NAPLAN Preparation, Selective Entry High School Preparation, the SEC Exam Course - all aligned to the Victorian Curriculum.',
    },
    {
      question: 'How can I register interest before opening?',
      answer: 'Email clyde.vic@schoololatutoring.com.au and we will add you to the Clyde list. You will be the first to hear about opening dates, enrolments and assessments.',
    },
    {
      question: 'Do you offer online tutoring in the meantime?',
      answer: 'Yes. Online tutoring is available across Victoria through our existing centres while the Clyde centre is being established.',
    },
  ],
};
